// Third-party Library
import React from "react"
import { Calendar, Col, Row, Space, Typography } from "antd"

// Constants
import { TEMPLATE } from '../../../../../../constants'

// Services Library
import { TIME } from "../../../../../../services/util"

// Styles
import styles from './index.module.css'

const { Text } = Typography

const {
    getCurTimeDayJS,
    isBetweenByDate,
    parseDate,
} = TIME

const {
    PRETRIP_HISTORY_STATUS_LABEL: statusConfig,
    PRETRIP_HISTORY_STATUS: STATUS
} = TEMPLATE.PRETRIP


// function getLatestDataPerDate(dataReport) {
//     return dataReport.reduce((acc, current) => {
//         const dateKey = current.date
//             ? current.date.replaceAll('-', '/')
//             : parseDate(current.createdAt)

//         const entry = {
//             dpid: current.dpid,
//             status: current.status,
//             driver: current.name,
//             plate: current.plate,
//             createdAt: current.createdAt,
//             note: current.note,
//             date: dateKey,
//         }

//         const existing = acc[dateKey]
//         if (!existing || current.createdAt > existing.createdAt) {
//             acc[dateKey] = entry
//         }

//         return acc
//     }, {})
// }

// function buildDefaultEntry(defaultSource, date) {
//     return {
//         status: STATUS.MISSING,
//         driver: defaultSource.name,
//         plate: defaultSource.plate,
//         createdAt: defaultSource.createdAt,
//         note: defaultSource.note,
//         date: parseDate(date ?? defaultSource.createdAt),
//     }
// }

const Legend = () => (
    <Row gutter={[16, 4]} style={{ marginTop: 12, paddingTop: 10, borderTop: "1px solid #f0f0f0" }}>
        {Object.entries(statusConfig).map(([key, cfg]) => (
            <Col key={key}>
                <Space size={4}>
                    <span className={styles["color-cfg"]} style={{ background: cfg.color }} />
                    <Text className={styles["label-cfg"]}>{cfg.label}</Text>
                </Space>
            </Col>
        ))}
        <Col>
            <Space size={4}>
                <span className={styles["empty-cfg"]} />
                <Text className={styles["label-cfg"]}>Not in Selected Period</Text>
            </Space>
        </Col>
    </Row>
)

const CellContent = ({ date, selectedDate, onSelect, data, isBetween }) => {

    const isFutureDate = date.isAfter(getCurTimeDayJS(), 'day')
    const shouldFallbackMissing = !isFutureDate && isBetween

    const shouldForceMissing =
        data
        && shouldFallbackMissing
        && data.status !== STATUS.SUBMITTED
        && data.status !== STATUS.OFF

    const cfg = data
        ? (shouldForceMissing ? statusConfig[STATUS.MISSING] : statusConfig[data.status])
        : (shouldFallbackMissing ? statusConfig[STATUS.MISSING] : null)

    const isCurrentMonth = selectedDate.format('MM') === getCurTimeDayJS().format('MM')
    const isSelected = parseDate(selectedDate) === parseDate(date)

    return (
        <div
            aria-hidden='true'
            onClick={() => onSelect(date)}
            className={styles["calendar-content"]}
            style={{
                background: cfg ? cfg.bg : "transparent",
                border: isSelected ? "2px solid #1d78c8" : "2px solid transparent",
                cursor: isSelected ? "pointer" : "default",
            }}
        >
            <span
                style={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: isCurrentMonth ? "#1a1a2e" : "#d1d5db",
                    alignSelf: "flex-start",
                    lineHeight: 1,
                    marginBottom: 2,
                }}
            >
                {date.format("DD")}
            </span>

            {cfg ? (
                <>
                    {cfg.icon}
                    <span className={styles["label-cfg"]} style={{ color: cfg.textColor }}>
                        {cfg.label}
                    </span>
                </>
            ) : (
                <span style={{ fontSize: 12, color: "#d1d5db" }}>–</span>
            )}
        </div>
    )
}

/**
 * Main Render
 */
const CalendarLayout = ({ handleSelectDate, dataSource, selectedDate, ...tableProps }) => {
    // const [selectedDate, setSelectedDate] = useState(getCurTimeDayJS())

    // const dataReport = tableProps.dataReport || []
    // const defaultSource = dataReport[0] || {}

    // const dataSource = useMemo(() => getLatestDataPerDate(dataReport), [dataReport])

    // useEffect(() => {
    //     const today = parseDate(getCurTimeDayJS())
    //     setData(dataSource[today] || buildDefaultEntry(defaultSource))
    // }, [])

    // const handleSelectDate = (date) => {
    //     const data = dataSource[parseDate(date)]
    //     setSelectedDate(date)
    //     setData(data || buildDefaultEntry(defaultSource, date))
    // }R

    const cellRender = (current, info) => {
        if (info.type !== "date") return info.originNode

        const currentDate = parseDate(current)
        const startDate = parseDate(tableProps.startTime)
        const endDate = parseDate(tableProps.endTime)

        const data = dataSource[currentDate]
        const isBetween = isBetweenByDate(currentDate, startDate, endDate)

        return (
            <CellContent
                isBetween={isBetween}
                data={data}
                date={current}
                selectedDate={selectedDate}
                onSelect={handleSelectDate}
            />
        )
    }

    return (
        <>
            <Calendar
                fullscreen={false}
                defaultValue={getCurTimeDayJS()}
                fullCellRender={cellRender}
                style={{ border: "none" }}
            />
            <Legend />
        </>
    )
}

export default React.memo(CalendarLayout)